/* unplugin-vue-components disabled */import script from "./selectSupplies.vue?vue&type=script&setup=true&lang=js"
export * from "./selectSupplies.vue?vue&type=script&setup=true&lang=js"

import "./selectSupplies.vue?vue&type=style&index=0&id=68a04193&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68a04193"]])

export default __exports__